import customAxios from './axios';
import CONFIG from '../../config';

const BASE = `${CONFIG.apiURL}/BiometricSlotSetting`;

export const getActiveCenters = () => {
    return customAxios.get(`${CONFIG.apiURL}/Icp/Public/GetActiveCenters`).then(res => res.data);
};

export const getGeneral = () => {
    return customAxios.get(`${BASE}/GetGeneral`).then(res => res.data);
};

export const updateGeneral = (body) => {
    return customAxios.put(`${BASE}/UpdateGeneral`, body).then(res => res.data);
};

export const getByCenter = (centerId) => {
    return customAxios.get(`${BASE}/GetByCenter`, { params: { centerId } }).then(res => res.data);
};

export const updateByCenter = (centerId, body) => {
    return customAxios.put(`${BASE}/UpdateByCenter`, body, { params: { centerId } }).then(res => res.data);
};

export const resetCenter = (centerId) => {
    return customAxios.delete(`${BASE}/ResetCenter`, { params: { centerId } }).then(res => res.data);
};

export const getDateOverrides = ({ centerId, from, to } = {}) => {
    const params = {};
    if (centerId !== null && centerId !== undefined && centerId !== '') params.centerId = centerId;
    if (from) params.from = from;
    if (to) params.to = to;
    return customAxios.get(`${BASE}/DateOverrides`, { params }).then(res => res.data);
};

export const createDateOverride = (body) => {
    return customAxios.post(`${BASE}/CreateDateOverride`, body).then(res => res.data);
};

export const updateDateOverride = (id, body) => {
    return customAxios.put(`${BASE}/UpdateDateOverride`, body, { params: { id } }).then(res => res.data);
};

export const deleteDateOverride = (id) => {
    return customAxios.delete(`${BASE}/DeleteDateOverride`, { params: { id } }).then(res => res.data);
};

export const getSlots = ({ centerId, date, slotStatus, gender }) => {
    const params = { centerId, date };
    if (slotStatus) params.slotStatus = slotStatus;
    if (gender) params.gender = gender;
    return customAxios.get(`${CONFIG.apiURL}/Icp/GetSlots`, { params }).then(res => res.data);
};

export const getCalendar = (centerId, month) => {
    return customAxios.get(`${BASE}/Calendar`, { params: { centerId, month } }).then(res => res.data);
};

const COUNTER_BASE = `${CONFIG.apiURL}/BiometricCounter`;

export const getCounters = (centerId) => {
    return customAxios.get(`${COUNTER_BASE}/List`, { params: { centerId } }).then(res => res.data);
};

export const createCounter = (centerId, body) => {
    return customAxios.post(`${COUNTER_BASE}/Create`, body, { params: { centerId } }).then(res => res.data);
};

export const updateCounter = (id, body) => {
    return customAxios.put(`${COUNTER_BASE}/Update`, body, { params: { id } }).then(res => res.data);
};

export const deleteCounter = (id) => {
    return customAxios.delete(`${COUNTER_BASE}/Delete`, { params: { id } }).then(res => res.data);
};
